import { gql } from '@apollo/client'

export const ORDER_MARK_NOT_RECEIVABLE_MUTATION = gql`
  mutation orderMarkNotReceivable($input: MarkOrderNotReceivableArgs!) {
    orderMarkNotReceivable(input: $input) {
      _id
      paymentStatus
      updatedAt
    }
  }
`
